var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsLikeIconDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-3140 -1546)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 22,
    height: 22,
    rx: 11,
    transform: "translate(3140 1546)",
    fill: "#226194"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7ad7e643fd05fe800b7ee6caa45a3c9b",
    "data-name": "7ad7e643fd05fe800b7ee6caa45a3c9b",
    transform: "translate(3142.335 1546.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M2.75,10.756a.506.506,0,0,1,.506-.506H5.617a.506.506,0,0,1,.506.506v6.071a.506.506,0,0,1-.506.506H3.256a.506.506,0,0,1-.506-.506Zm1.012.506v5.059H5.111V11.262Z",
    transform: "translate(0 -1.863)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M11.266,5.686a.506.506,0,0,0-.838.2L9.934,7.366a.506.506,0,0,1-.1.178L8.312,9.231a.506.506,0,0,1-.376.167H7.262v5.059H9.454a.506.506,0,1,1,0,1.012h-2.7a.506.506,0,0,1-.506-.506V8.893a.506.506,0,0,1,.506-.506h.955l1.3-1.44.461-1.382a1.518,1.518,0,0,1,2.513-.593l.136.136a1.518,1.518,0,0,1,.408,1.4l-.417,1.878H14.18a1.855,1.855,0,0,1,1.811,2.257l-.808,3.637A1.518,1.518,0,0,1,13.7,15.469H12.152a.506.506,0,1,1,0-1.012H13.7a.506.506,0,0,0,.494-.4L15,10.425A.843.843,0,0,0,14.18,9.4h-2.7a.506.506,0,0,1-.494-.616l.554-2.493a.506.506,0,0,0-.136-.467Z",
    transform: "translate(-1.139)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsLikeIconDark);
export default __webpack_public_path__ + "static/media/thumbs-like-icon-dark.d47b850bb1b60ec1b935c54fb81abbe5.svg";
export { ForwardRef as ReactComponent };